export { default } from './MainService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/main/services/MainService/index.js